import type { UseMutateFunction } from '@tanstack/react-query';
import type { ErrorReportBody } from '../requests/support-message-requests';
import type { MessageOnlyResponse } from '@/types/messageOnlyResponse';

const recentErrors = new Set();
const DEBOUNCE_TIME_MS = 5000; // 5 seconds

function generateErrorId(error: { type: string }) {
  return `${error.type}`;
}

const reportError = (
  errorDetails: { type: string; [key: string]: unknown },
  mutate: UseMutateFunction<MessageOnlyResponse, Error, ErrorReportBody>
) => {
  if (!errorDetails) return;

  const errorId = generateErrorId(errorDetails);

  // If this error has been reported recently, ignore it
  if (recentErrors.has(errorId)) {
    return;
  }

  recentErrors.add(errorId);
  setTimeout(() => recentErrors.delete(errorId), DEBOUNCE_TIME_MS);

  mutate({
    error_data: JSON.stringify(errorDetails),
  });
};

export default reportError;
